<p-menubar [model]="items">
    <ng-template #end>
        <div class="flex items-center gap-2">
            <p-button [label]="username" icon="pi pi-user" (click)="menu.toggle($event)" />
            <p-menu #menu [model]="userItems" [popup]="true" />
        </div>
    </ng-template>
</p-menubar>

<p-dialog header="Locate deal" [modal]="true" [(visible)]="dealLocator" [style]="{ width: '25rem' }">
    <span class="p-text-secondary block mb-2">Enter Deal Pipedrive Id</span>
    <div class="flex items-center gap-4 mb-4">
        <input #dealInput pInputText class="flex-auto" [(ngModel)]="dealId" autocomplete="off"
            (keyup.enter)="dealKeyPressed($event)" />
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="dealLocator = false" />
        <p-button label="Locate" [disabled]="dealId == null || !(dealId > 0)" (click)="locateDeal()" />
    </div>
</p-dialog>